import { render } from "./VehicleOrderTemplateComponent.vue?vue&type=template&id=9cb70166&ts=true"
import script from "./VehicleOrderTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleOrderTemplateComponent.vue?vue&type=script&lang=ts"

import "./VehicleOrderTemplateComponent.vue?vue&type=style&index=0&id=9cb70166&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__